import React from 'react'
import YouTube from 'react-youtube'

const PoiVideo = ({ poi }) => {
  if (poi.youtubeVideoUrl) {
    const opts = {
      playerVars: {
        autoplay: 0,
      },
    }

    return (
      <>
        <div className="video-container">
          <YouTube
            videoId={poi.youtubeVideoUrl}
            opts={opts}
            className="react-player"
          />
        </div>
      </>
    )
  }
  return null
}

export default PoiVideo
